import { FC, useContext, useEffect, useState } from "react";

import {
  Typography,
  Grid,
  Container,
  Box,
  useMediaQuery,
  Button,
  Divider,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import AdminHeader from "../SubComponents/AdminHeader";
import useStyles from "../Styles/LearnStyles";
import Footer from "../SubComponents/Footer";
import prize from "../../assets/images/prize.png";

import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";

import FormControlLabel from "@material-ui/core/FormControlLabel";

import Expand from "../../assets/images/Expand.svg";
import correct from "../../assets/images/correct.svg";
import wrong from "../../assets/images/Wrong.svg";
import { useHistory, useParams } from "react-router";
import { useLearnContext } from "../../store/Learn2/LearnContext";
import { filterQuizzesByPool } from "../../store/Learn2/LearnFunction";
import { applyToPoolWhitelistFunction } from "../../store/Pool/PoolFunction";
import AlertContext from "../../store/Alert/AlertContext";
import Loader from "../../helpers/Loader";
import LearnProgressCards, { QuizState } from "./LearnProgressCards";
import HorizontalNonLinearStepper from "../ConnectWallet/WalletStepperNew";
import PoolContext from "../../store/Pool/PoolContext";

const ExpandIcon = () => {
  return <img src={Expand} alt="gains" className="img-fluid " />;
};

const CorrectIcon = () => {
  return <img src={correct} alt="gains" className="img-fluid ml-img  " />;
};

const WrongIcon = () => {
  return <img src={wrong} alt="gains" className="img-fluid  ml-img " />;
};

const LearnResult: FC = () => {
  const { id: poolId }: any = useParams();
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  const { getPoolById, getPoolPledges, userPledges, getUserListPledge } = useContext<any>(PoolContext);
  const { 
    quizzes,
    activeQuizSubmissions,
    quizTracker,
    quizIndex,
    currentQuizQuestionsWithDetails,
    resetLearnState, 
    resetQuizState,
    activeQuizzes,
    getAuthUserPoolQuiz,
    getPoolQuizzes,
    setQuizIndex,
    quizStatus,
    setQuizAttempt,
  } = useLearnContext();
  const { setAlert } = useContext<any>(AlertContext);


  const [currentQuiz, setCurrentQuiz] = useState<any>();
  const [currentPoolQuizzes, setCurrentPoolQuizzes] = useState<any[]>([]);
  const [totalQuestion, setTotalQuestion] = useState<number>(0);
  const [totalScore, setTotalScore] = useState<number>(0);
  const [totalCorrect, setTotalCorrect] = useState<number>(0);
  const [totalIncorrect, setTotalIncorrect] = useState<number>(0);
  const [quizFailed, setFailed] = useState<boolean>(false);
  const [showResultModal, toggleResultModal] = useState<boolean>(false);
  const [resultStatus, setResultStatus] = useState<QuizState | null>(null);
  const [attemptsLeft, setAttemptsLeft] = useState<number | null>(null);
  const [tickets, setTotalTickets] = useState<number | null>(null);
  const [currentQuizSubmissions, setCurrentQuizSubmissions] = useState<any[]>([]);
  const [currentQuizQuestions, setCurrentQuizQuestions] = useState<any[]>([]);
  const [currentPool, setCurrentPool] = useState<any>();
  const [hasWhitelisted, setWhitelisted] = useState<boolean>(false);

  useEffect(() => {
    getAuthUserPoolQuiz();
    const pool = getPoolById(poolId);
    if (pool && pool.length > 0)
    setCurrentPool(pool[0]);
  }, []);

  useEffect(() => {
    if (!quizTracker) {
      let currentPoolQuiz = activeQuizzes?.find((active: any) => active.poolId === poolId);
      let currentPoolQuizzes = currentPoolQuiz?.quizzes;
      if (!currentPoolQuizzes || currentPoolQuizzes.length === 0) return;
      // We should get the quiz tracker of the quiz 
      // with the highest end time - end time should not be 
      // null since we are on a result page 
      let mostRecentAttempts = currentPoolQuizzes[0];
      for (let i = 1; i < currentPoolQuizzes.length; i++) {
        const currentAttemptEndTime = new Date(currentPoolQuizzes[i].lastAttempt?.end_time);
        const mostRecentAttemptEndTime = new Date(mostRecentAttempts.lastAttempt?.end_time);
  
        if (currentAttemptEndTime > mostRecentAttemptEndTime) {
          mostRecentAttempts = currentPoolQuizzes[i];
        }
      }
      
      const quizTracker = {
        pool_id: poolId,
        quiz_id: mostRecentAttempts.quizId,
        ...mostRecentAttempts.lastAttempt
      }
      setQuizAttempt(quizTracker)
    }
  }, [activeQuizzes])

  useEffect(() => {
    if (quizzes && quizzes.length === 0) getPoolQuizzes(poolId);
    else {
      if (!quizTracker) return;
      const currentQuiz = quizzes?.filter((quiz: any) => {
        return quiz && quiz.id === quizTracker.quiz_id;
      })[0] ?? { orderNumber: 0};
      setCurrentQuiz(currentQuiz);
      if (quizIndex < 0) {
        setQuizIndex(currentQuiz.orderNumber - 1);
      }
      const currentPoolQuizzes = filterQuizzesByPool(quizzes!, poolId);
      setCurrentPoolQuizzes(currentPoolQuizzes);
    }
  }, [quizzes, quizTracker])

  useEffect(() => {
    if (!quizTracker) return;
    const currentQuizSubmissions = activeQuizSubmissions.filter((submission : any) => {
      return submission.quizId === quizTracker.quiz_id && submission.poolId === quizTracker.pool_id
    });
    setCurrentQuizSubmissions(currentQuizSubmissions);
    const currentQuizQuestions = currentQuizQuestionsWithDetails.filter((quizWithDetail: any) => {
      return quizWithDetail.quizId === quizTracker.quiz_id
    })
    setCurrentQuizQuestions(currentQuizQuestions);
  }, [quizTracker, activeQuizSubmissions, currentQuizQuestionsWithDetails])

  useEffect(() => {
    setTotalQuestion(currentQuizSubmissions.length);
    let totalScore = 0;
    let totalCorrect = 0;
    let totalIncorrect = 0;
    currentQuizSubmissions.map((submissions: any) => {
      totalScore = totalScore + submissions.answerResponse.points;
      if (submissions.answerResponse.isCorrect) totalCorrect = totalCorrect + 1;
      else totalIncorrect = totalIncorrect + 1;
    })
    setTotalScore(totalScore);
    setTotalCorrect(totalCorrect)
    setTotalIncorrect(totalIncorrect);
  }, [currentQuizSubmissions])
  
  // TODO: Revisit the logic.
  useEffect(() => {
    if (!quizTracker) return;
    let currentQuizActive = activeQuizzes.filter((active: any) => {
      return active.poolId === poolId
    })
    if (currentQuizActive && currentQuizActive.length > 0 ) {
      const hasFailed = currentQuizActive[0]?.quizzes?.filter((quiz: any) => {
        return quiz.numberOfAttempts === 3 && quiz.lastAttempt.isSuccessful === false;
      })
      if (hasFailed && hasFailed.length > 0) {
        setFailed(true);
        setAttemptsLeft(0);
        setResultStatus('poolQuizFail');
        toggleResultModal(true);
      } else {
        if (!quizTracker.isSuccessful) {
          // REDO
          // TODO: attempts
          setResultStatus('quizFail')
          toggleResultModal(true);
        } else if (currentPoolQuizzes.length > 0) {
          if (currentPoolQuizzes.length > quizIndex + 1) {
            // Next video
            setResultStatus('quizSuccess');
            toggleResultModal(true);
          } else {
            // Check if whitelisted
            // if whitelisted show alert and allow return to home
            // else show modal to apply for whitelist
            const hasPledged = userPledges.filter((pledge: any) => pledge.poolId === poolId);
            if ((hasPledged && hasPledged.length > 0) || hasWhitelisted) {
              setAlert('You have already pledged for this pool, please await lottery.', 'info');
            } else {
              handleApplyToWhitelist();
            }
          }
        }
      }
    }
  }, [activeQuizzes, quizTracker]);

  useEffect(() => {
    if (activeQuizzes && currentQuiz) {
      let currentPoolActiveQuiz = activeQuizzes
      .find((active: any) => active.poolId === poolId)
      .quizzes.filter((active: any) => active.quizId === currentQuiz.id);
      let attempts = currentPoolActiveQuiz[0]?.numberOfAttempts;
      setAttemptsLeft(3 - attempts);
    }
  }, [activeQuizzes, currentQuiz])

  const handleRedo = (event: any) => {
    resetQuizState();
    history.push(`/learn/${poolId}`);
  };

  const handleNextVideo = async (event: any, reason?: string) => {
    if (showResultModal) toggleResultModal(false);
    if (quizFailed) {
        resetLearnState();
        history.push(`/learn-result-fail`);
        return;
    }
    if (currentPoolQuizzes?.length === quizIndex + 1) {
      // check if already not whitelisted
      const hasPledged = userPledges.filter((pledge: any) => pledge.poolId === poolId);
      if ((hasPledged && hasPledged.length > 0) || hasWhitelisted) {
        setAlert('You have already pledged for this pool, please await lottery.', 'info');
        history.push(`/deals`);
      } else {
        handleApplyToWhitelist();
      }
    } else {
      resetQuizState();
      history.push(`/learn/${poolId}`);
    }
  };

  const handleApplyToWhitelist = async () => {
    setWhitelisted(true);
    setAlert("Finalising quiz submission, please wait...", "info", 2000);
    applyToPoolWhitelistFunction(poolId)
      .then((response: any) => {
        // show the modal
        setTotalTickets(response.applyToPoolWhitelist.allocatedTickets);
        setResultStatus('whitelistCompleted');
        toggleResultModal(true);
        getUserListPledge();
      })
      .catch((error: any) => {
        const alreadyAppliedError = error.response?.errors?.find((err: any) => err.message === "Already applied for whitelisting on pool");
        if (alreadyAppliedError) {
          setAlert('You have already applied for whitelisting on this pool', 'error');
          history.push(`/deals`);
        }
        else setAlert("Pool whitelist failed. Please try again later.", "error");
      });
  }

  return (
    <>
      <AdminHeader isProject={true} />
      <HorizontalNonLinearStepper
          projectChangeEnabled={false}
          disableModals={false}
          finished={true}
      />
      <Box mt={3}>
        <Divider />
      </Box>

      <Box className={classes.learnpages} component="section">
        <Container fixed>
          <Grid container justifyContent="center">
            <Grid item lg={10} md={9} sm={12} xs={12} className="border-right">
              {
                (currentQuiz)
                ? (
                  <Box
                    mt={isActive ? 3 : 5}
                    ml={isActive ? 0 : 0}
                    className="res-box"
                  >
                    <Box mt={isActive ? 2 : 3} mb={isActive ? 2 : 0} display="flex">
                      <Typography variant="h3" color="secondary">
                        Results of {currentQuiz?.description?.toUpperCase()}
                      </Typography>
                    </Box>

                    <Box
                      py={isActive ? 3 : 3}
                      pr={isActive ? 0 : 0}
                      pl={isActive ? 0 : 3}
                      mt={2}
                      mr={isActive ? 0 : 3}
                      className="box-border-main"
                    >
                      <Box
                        display="flex"
                        flexDirection={isActive ? "column" : "row"}
                        alignItems={isActive ? "center" : null}
                        pl={isActive ? 3 : ""}
                      >
                        {" "}
                        {/**item flex box */}
                        <Box className="prize-box" mr={isActive ? 0 : 10}>
                          <img src={prize} alt="gains" className="img-fluid " />
                        </Box>{" "}
                        {/**main flex box */}
                        <Box
                          display="flex"
                          flexDirection="column"
                          className="suode-box"
                        >
                          {" "}
                          {/**flex box item */}
                          <Box mt={isActive ? 2 : 0}>
                            <Typography variant="h4" color="secondary">
                              Results details
                            </Typography>
                          </Box>
                          <Box mt={2}>
                            <Grid container>
                              <Grid item md={2} xs={6}>
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  mr={5}
                                  mb={isActive ? "12px" : 0}
                                >
                                  {" "}
                                  {/**flex box item */}
                                  <Typography
                                    variant="body1"
                                    className="fw-bold"
                                    color="primary"
                                  >
                                    { totalScore }
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="body-color fw-normal"
                                  >
                                    Score
                                  </Typography>
                                </Box>
                              </Grid>

                              <Grid item md={4} xs={6}>
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  mr={5}
                                  mb={isActive ? "12px" : 0}
                                >
                                  {" "}
                                  {/**flex box item */}
                                  <Typography
                                    variant="body1"
                                    color="primary"
                                    component="span"
                                    className="fw-bold"
                                  >
                                    { totalQuestion }
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="body-color fw-normal"
                                    component="span"
                                  >
                                    TotalQuestions
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item md={2} xs={6}>
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  mr={5}
                                  mb={isActive ? "12px" : 0}
                                >
                                  {" "}
                                  {/**flex box item */}
                                  <Typography
                                    variant="body1"
                                    className="fw-bold"
                                    color="primary"
                                  >
                                    { totalCorrect }
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="body-color fw-normal"
                                  >
                                    Correct
                                  </Typography>
                                </Box>
                              </Grid>
                              <Grid item md={4} xs={6}>
                                <Box
                                  display="flex"
                                  flexDirection="column"
                                  mr={5}
                                  mb={isActive ? "12px" : 0}
                                >
                                  {" "}
                                  {/**flex box item */}
                                  <Typography
                                    variant="body1"
                                    className="fw-bold"
                                    color="primary"
                                  >
                                    { totalIncorrect }
                                  </Typography>
                                  <Typography
                                    variant="subtitle1"
                                    className="body-color fw-normal"
                                  >
                                    Incorrect
                                  </Typography>
                                </Box>
                              </Grid>
                            </Grid>
                          </Box>
                        </Box>
                      </Box>

                      {/*** accordion */}

                      <Box
                        mt={isActive ? 2 : 4}
                        className="accordion-box scroller"
                        ml={isActive ? 2 : 0}
                      >
                        {currentQuizQuestions.map((q: any, index: any) => (
                          <Accordion key={index}>
                            <AccordionSummary
                              expandIcon={<ExpandIcon />}
                              aria-label="Expand"
                              aria-controls="additional-actions1-content"
                              id="additional-actions1-header"
                              className={classes.hideArrow}
                            >
                              <FormControlLabel
                                aria-label="Acknowledge"
                                onClick={(event) => event.stopPropagation()}
                                onFocus={(event) => event.stopPropagation()}
                                control={
                                  currentQuizSubmissions.filter((submission: any) => {
                                    return submission.questionId === q.questionDetail.id
                                  })[0]?.answerResponse?.isCorrect
                                  ? (
                                    <CorrectIcon />
                                  ) : (
                                    <WrongIcon />
                                  )
                                }
                                label={
                                  <Box ml={isActive ? "12px" : 3}>
                                    <Typography variant="h4" color="secondary">
                                      {q.questionDetail?.question}
                                    </Typography>
                                  </Box>
                                }
                              />
                            </AccordionSummary>
                          </Accordion>
                        ))}
                      </Box>

                      {/** section last button box */}
                    </Box>
                    
                    { /** 70 should be replaced by a dynamic value */}
                    <Box
                      mt={isActive ? 4 : 5}
                      mb={isActive ? 3 : 10}
                      display="flex"
                    >
                      {!quizTracker?.isSuccessful && !quizFailed ? (
                        <Button
                          variant="outlined"
                          color="secondary"
                          className="learn-button"
                          onClick={handleRedo}
                        >
                          Redo
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="secondary"
                          className="learn-button"
                          onClick={handleNextVideo}
                          disabled={
                            currentPoolQuizzes?.length === quizIndex + 1 && !quizFailed
                              ? true
                              : false
                          }
                        >
                          {
                            currentPoolQuizzes?.length > quizIndex + 1 && !quizFailed
                            ? "Go to Next Video"
                            : "Go to Result"
                          }
                        </Button>
                      )}
                    </Box>
                  </Box>
                )
                : (
                  <Box my={10}>
                          <Loader />
                  </Box>
                )
              }
            </Grid>
          </Grid>
          {
            showResultModal && (
              <LearnProgressCards open={showResultModal} setOpen={toggleResultModal} state={resultStatus} attempts={attemptsLeft} tickets={tickets} next={handleNextVideo} projectName={currentPool?.name} projectImage={currentPool?.image} socialLink={currentPool?.socialNetworks?.twitter} quizStatus={quizStatus} />
            )
          }
        </Container>
      </Box>

      <Footer />
    </>
  );
};

export default LearnResult;
